import { HashRouter, Route } from 'react-router-dom'
import Header from './Header'
import Main from './Main'
import Common from './Common'
import './common.css'
import Trailer from './Trailer'
import Characters from './Characters'
import Synopsis from './Synopsis'

function App() {
    return (
        <div id='wrap'>
            <HashRouter>
                <Route path="/" component={ Header } />
                <Route exact={true} path="/" component={ Main } />
                <Route path="/" component={ Common } />
                <Route path="/trailer" component={ Trailer } />
                <Route path="/characters" component={ Characters } />
                <Route path="/synopsis" component={ Synopsis } />
            </HashRouter>
        </div>
    );
}

export default App;